var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary m-0",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.openModal.apply(null, arguments)}}},[_vm._v("\n    Sync All Passare\n")])}
var staticRenderFns = []

export { render, staticRenderFns }